import { render } from "./ValidationHistoryEmptySearch.vue?vue&type=template&id=3e8a5566"
import script from "./ValidationHistoryEmptySearch.vue?vue&type=script&lang=js"
export * from "./ValidationHistoryEmptySearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__